import { render, staticRenderFns } from "./ConsentFormPerviewModal.vue?vue&type=template&id=2bbb9c6c&scoped=true"
import script from "./ConsentFormPerviewModal.vue?vue&type=script&lang=js"
export * from "./ConsentFormPerviewModal.vue?vue&type=script&lang=js"
import style0 from "./ConsentFormPerviewModal.vue?vue&type=style&index=0&id=2bbb9c6c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bbb9c6c",
  null
  
)

export default component.exports